import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { ChartConfiguration, ChartData } from 'chart.js';

export interface VendorsByMdaPoint {
  label: string;
  count: number;
}

@Component({
  selector: 'app-vendors-by-mda-chart',
  standalone: true,
  imports: [CommonModule, BaseChartDirective],
  templateUrl: './vendors-by-mda-chart.component.html',
  styleUrl: './vendors-by-mda-chart.component.scss',
})
export class VendorsByMdaChartComponent implements OnInit {
  @Input() title = 'Vendor by MDAs';
  @Input() data: VendorsByMdaPoint[] = [];

  barChartOptions: ChartConfiguration<'bar'>['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: '#1F2937',
        titleColor: '#F9FAFB',
        bodyColor: '#F9FAFB',
        padding: 12,
        cornerRadius: 8,
        displayColors: false,
        callbacks: {
          label: (context) => `${context.parsed.y} vendors`,
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: {
          color: '#6B7280',
          font: { size: 12, family: 'Inter' },
        },
        border: { display: false },
      },
      y: {
        beginAtZero: true,
        ticks: {
          color: '#9CA3AF',
          font: { size: 11, family: 'Inter' },
          padding: 8,
        },
        grid: { color: '#F3F4F6', lineWidth: 1 },
        border: { display: false },
      },
    },
    animation: { duration: 900, easing: 'easeOutQuart' },
  };

  barChartData: ChartData<'bar'> = {
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: '#1693AA',
        borderRadius: 6,
        borderSkipped: false,
        barPercentage: 0.65,
        categoryPercentage: 0.75,
      },
    ],
  };

  ngOnInit(): void {
    this.updateChartData();
  }

  ngOnChanges(): void {
    this.updateChartData();
  }

  private updateChartData(): void {
    if (!this.data?.length) return;
    this.barChartData = {
      labels: this.data.map((d) => d.label),
      datasets: [
        {
          data: this.data.map((d) => d.count),
          backgroundColor: '#1693AA',
          borderRadius: 6,
          borderSkipped: false,
          barPercentage: 0.65,
          categoryPercentage: 0.75,
        },
      ],
    };
  }
}

